<template>
  <div class="p-pnt">
    <ModalError :visible="showModalError" :errorType="errorType" ></ModalError>
    <div class="l-container">
      <!-- <div class="c-box mb-16 mt-px"> -->
        <div  class="p-menus-no__summary">
          <div class="p-menus-no__menuInfo">
            <div class="p-menus-no__menuInfo__label title-left">
              <div class="label-contents">
                <div class="p-menus-no__menuInfo__label cat-nm">
                  <span
                    v-if="headerData"
                    class="p-menus-no__menuInfo__menuNo text-menu"
                  >
                    {{ getCatNm() }}
                  </span>
                </div>
                <!-- <div class="content_btns_sp">
                  <Share 
                    :facebook="false"
                    :twitter="false"
                    :line="false"
                    :email="false"
                    :social="false"
                    size="large"
                    :copyLabel="copyLabel"
                  />
                  <div
                    class="content_shareBtn_btn"
                    @click="() => { $refs['share-modal'].showModal() }"
                  >
                    <span class="content_shareBtn_btn_text">共有</span>
                    <span class="content_shareBtn_btn_icon">
                      <Icon name="action_share" fill="#000" />
                    </span>
                  </div>
                  <ShareModal
                    ref="share-modal"
                    :copyText="copyText"
                    @click-mail="() => { $refs['pop-up-send-mail'].showModal() }"
                  />
                  <PopUpSendMail
                    ref="pop-up-send-mail"
                    v-bind="mailParams"
                  />
                  <div
                    class="
                      p-menus-no__menuInfo__menulist__item
                      sep
                    "
                    @click="handleFavorite"
                  >
                    <Icon
                       width="20"
                      height="20"
                      name="action_favorite_fill"
                      color="#EF3D55"
                      v-if="isFavorited"
                    />
                    <Icon
                      width="20"
                      height="20"
                      name="action_favorite_add"
                      v-if="!isFavorited"
                    />
                  </div>
                </div> -->
              </div>

              <p v-if="headerData" class="p-menus-no__menuInfo__menuNo"
                >[メニューNo. {{ headerData.menuNo }}]
              </p>
            </div>
            <div class="p-menus-no__menuInfo__share">
              <Share 
                :facebook="false"
                :twitter="false"
                :line="false"
                :email="false"
                :social="false"
                size="large"
                :copyLabel="copyLabel"
              />
            </div>
            <!-- <div class="p-menus-no__menuInfo__menu">
              <div class="p-menus-no__menuInfo__menulist">
                <div class="p-menus-no-mt-15">
                  <Share 
                    :facebook="false"
                    :twitter="false"
                    :line="false"
                    :email="false"
                    :social="false"
                    size="large"
                    :copyLabel="copyLabel"
                  />
                
                  <div
                    class="
                      p-menus-no__menuInfo__menulist__item
                      p-menus-no__menuInfo__menulist__item--copy
                      sep
                    "
                  >
                    <a
                      class="c-button__tertiary sp-button__tertiary"
                      @click.prevent="CopyToClipboard(copyText)"
                      href="javascript:;"
                    >
                      <span>内容をコピー</span>
                    </a>
                  </div>
                  <div
                    class="
                      p-menus-no__menuInfo__menulist__item
                      sep
                    "
                    @click="handleFavorite"
                  >
                    <Icon
                      width="20"
                      height="20"
                      name="action_favorite_fill"
                      color="#EF3D55"
                      v-if="isFavorited"
                    />
                    <Icon
                      width="20"
                      height="20"
                      name="action_favorite_add"
                      v-if="!isFavorited"
                    />
                  </div>
                 </div>
            </div>
            </div> -->
          </div>
          <h1 v-if="headerData" class="p-menus-no__menuInfo__name" :class="{'p-menus-no__menuInfo__name__not--location': !(menu && menu.menuBasicInfo && menu.menuBasicInfo.areaInfomation)}">
            {{ headerData.menuNm }}
          </h1>
          <template>
            <ul class="content_icons">
              <template v-for="item in menuCafeSubsidyIcons()">
                <li
                  :key="item"
                  v-if="item.match(/カフェ/) || item.match(/補助/)"
                  :class="[
                    item.match(/カフェ/) || item.match(/補助/)
                    ? 'cafe-subsidy-icon'
                    : 'benepo-icon'
                  ]"
                >
                  {{ item }}
                </li>
              </template>
              <template v-for="item in menuCafeSubsidyIcons()">
                <li
                  :key="item"
                  v-if="!item.match(/カフェ/) && !item.match(/補助/)"
                  :class="[
                    item.match(/カフェ/) || item.match(/補助/)
                    ? 'cafe-subsidy-icon'
                    : 'benepo-icon'
                  ]"
                >
                  {{ item }}
                </li>
              </template>
            </ul>
          </template>
          <ul
            v-if="menu && menu.menuBasicInfo && menu.menuBasicInfo.areaInfomation"
            class="p-menus-no__menuInfo__location"
          >
            <li class="p-menus-no__menuInfo__location__text">
              <span v-if="menu.menuBasicInfo && (menu.menuBasicInfo.areaInfomation.areaLrgClassNm || menu.menuBasicInfo.areaInfomation.areaMidClassNm || menu.menuBasicInfo.areaInfomation.areaSmlClassNm )"><Icon  width="20" height="20" name="status_map" /></span>
              <span  v-if="menu.menuBasicInfo && (menu.menuBasicInfo.areaInfomation.areaLrgClassNm || menu.menuBasicInfo.areaInfomation.areaMidClassNm || menu.menuBasicInfo.areaInfomation.areaSmlClassNm)">
              {{ menu.menuBasicInfo.areaInfomation.areaLrgClassNm }}>
              {{ menu.menuBasicInfo.areaInfomation.areaMidClassNm }}>
              {{ menu.menuBasicInfo.areaInfomation.areaSmlClassNm }}
              </span>
            </li>
            <li
              class="p-menus-no__menuInfo__location__button"
              v-if="
                (menu.menuBasicInfo && 
                menu.menuBasicInfo.srvicDiv !== this.CONST_DATA.SRVIC_DIV.ENTERTAINMENT) &&
                menu.facilities &&
                menu.facilities.facilities &&
                menu.facilities.facilities.length === 1
              "
            >
              <a class="c-button__tertiary" :href="mapCoordinate"
                >地図<span>を見る</span></a
              >
            </li>
          </ul>
        </div>
        <MenuNavigation />
        <router-view
          :menu="menu"
           ref="routerViewRef"
        />
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
// import Header from './Header'
import MenuNavigation from './MenuNavigation'
import ShareModal from './components/ShareModal'
import { BREADCRUMBS } from '@/store/modules/app/actions'
// import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions'
import mark_watched from '@/mixins/mark_watched'
import { getCookieValue } from '@/utils/cookie'
import moment from "moment";

export default {
  name: 'MenuMainContainer',
  components: {
    // Header,
    MenuNavigation,
    ShareModal
  },
  mixins: [mark_watched],
  data() {
    return {
      showModalError: false,
      errorType: '',
      menu:null,
      isFavorited: false,
      favoriteId: null,
      copyText: '',
      mailParams:null,
      mapCoordinate:'',
      menuIcons:'',
      subsidyData: [],
      iconData: []
    }
  },
  async created() {
   await this.getMenuBasicInfo()


   let currentPagePath = this.$route.path
   if(this.menu?.menuBasicInfo?.extSystemCd && !['jadp','jato'].includes(this.menu.menuBasicInfo.extSystemCd) ) {
     await this.getSubsidy()
     // マッピングアイコン取得にはプラン情報と補助金両方のデータが必要
     if (Array.isArray(this.subsidyData) && this.subsidyData.length > 0) {
      // 補助金アイコンだけ判別できれば良いため、データ不要のはず
       this.getSubsidyIcon(this.subsidyData); 
       // 利用可能補助金ありのフラグを立てる
       this.canSubsidyFlg = true;
     }else {
       this.canSubsidyFlg = false;
     }
   }
   this.getCafeIcon();
  },
  // mounted() {
  //   this.addInListHistory()
  // },
  watch: {
    // ルート変更を監視してcopyLabelを再実行
    '$route': {
      handler(newRoute, oldRoute) {
        // メニュー基本情報を再取得してからcopyLabelを更新
        this.refreshMenuAndCopyLabel()
      },
      immediate: true // 初回マウント時も実行
    }
  },
  computed: {
    headerData() {
      if (!this.menu || !this.menu.headerData) return {};
      return this.menu.headerData;
    },
    menuBasicInfo(){
      return this.menu?.menuBasicInfo || {}
    },
    copyLabel() {
      let label = ''
      let menuNm = this.headerData.menuNm
      let dpPlanBasicInfo = this.getDpPlanBasicInfo()
      if (dpPlanBasicInfo) {
        label = dpPlanBasicInfo.planNm
      }
      return [menuNm, label].filter(Boolean).join('\n')
    },
  },
  methods: {
    async getMenuBasicInfo() {

      const { menuNo } = this.$route.params
      await this.$repositories('menu')
      .getDPMenuBasicInfo(menuNo)
      .then(
        (result) => {
          this.menu = result.data
          this.$set(this, "menu", result.data);
          this.isLoading = false;

          // DPメニューのアイコンはプランのアイコン情報をもとに表示させる
          // ライフのようにOpenSearchからアイコン情報取得もしくは、宿泊のようにapiのレスポンスでアイコンの判別が困難だったため
          const plansLength = this.menu.plans.length
          const iconSet = new Set();
          for (let i = 0; i < plansLength; i++) {
            let icons = this.menu.plans[i].planIcons
            icons.forEach(item => {
              if (item?.iconNm) {
                iconSet.add(item.iconNm)
              }             
            });
          }
          this.menuIcons = iconSet
        },
        (error) => {
          this.isLoading = false;
          if (error && (+error.status == 401 || +error.status == 404)) {
            this.showModalError = true
          }
        }
      )

          // update breadcrumbs
      let breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
      if(breadcrumbs.length < 3) {
        breadcrumbs.push({
          title: _.get(this.menuBasicInfo, 'menuNm', '')
        })
      }

      // CookieにDP検索結果を保存しているため、値を取り出す
      const searchResultTour = getCookieValue('search_result_tour')
      const cookieValue = searchResultTour ? JSON.parse(searchResultTour) : ''
      // カフェ補助アイコンが表示されなくなるといった不具合がでるため、Cookieが設定されていなければ、検索結果一覧の設定はしない
      if (cookieValue) {
        let searchResultTourUrl = cookieValue.url;
        // url作成用の連想配列作成
        const pathValue = {
          type: cookieValue?.type || null,
          keyword: cookieValue?.keyword || null,
          areaMidClassCd: cookieValue?.areaMidClassCd || null,
          areaSmlClassCd: cookieValue?.areaSmlClassCd || null,
          areaDtlClassCd: cookieValue?.areaDtlClassCd || null,
          checked: cookieValue?.checked || null,
          catLrgClassCd: cookieValue?.catLrgClassCd || null,
          catMidClassCd: cookieValue?.catMidClassCd || null,
          catSmlClassCd: cookieValue?.catSmlClassCd || null
        }
        // DP検索用のurlを作成する
        for (var options in pathValue) {
          if (cookieValue[options] && cookieValue[options].length !== 0) {
            if (options === 'type') {
              searchResultTourUrl += '?' + options + '=' + cookieValue[options]
              continue;
            }
            searchResultTourUrl += '&' + options + '=' + cookieValue[options]
          }
        }

        breadcrumbs[1].path = searchResultTourUrl
      }
      this.$store.dispatch(BREADCRUMBS, breadcrumbs)
      // const favoriteStatus = await this.getFavoriteStatus(this.menuNo);
      // this.isFavorited = _.get(favoriteStatus, "favourite", false);
      // this.favoriteId = _.get(favoriteStatus, "id");
     
    },
    handleFavorite() {
      const menuNo = this.$route.params.menuNo.replace("menuNo=", "");
      if (this.isFavorited) {
        this.removeFavorite(this.favoriteId).then(() => {
          this.favoriteId = null;
          this.isFavorited = false;
        });
      } else if (this.$auth.loggedIn) {
        this.addFavorite(menuNo).then((result) => {
          this.favoriteId = _.get(result, "id");
          this.isFavorited = true;
        });
      } else {
        // OPEN POPUP LOGIN
        this.$modal.open("LoginGuidanceModal");
      }
    },
    getCatNm() {
      const catLrgClassNm = _.get(
        this.menu,
        "menuBasicInfo.categoryInfomation.catLrgClassNm",
        null
      );
      const catMidClassNm = _.get(
        this.menu,
        "menuBasicInfo.categoryInfomation.catMidClassNm",
        null
      );
      const catSmlClassNm = _.get(
        this.menu,
        "menuBasicInfo.categoryInfomation.catSmlClassNm",
        null
      );
      return [catLrgClassNm, catMidClassNm, catSmlClassNm]
        .filter((item) => {
          return item;
        })
        .join("・");
    },
    menuCafeSubsidyIcons() {
      this.iconData.forEach((icon)=>{
        if (icon?.iconNm) {
          this.menuIcons.add(icon.iconNm)
        }
      });
      // アイコンのsortを行い、検索結果画面と同じアイコンの並びとする
      return Array.from(this.menuIcons).sort();
    },
    async getSubsidy() {
      let tmpSubsidyData = await this.getCouponData();

      if (!tmpSubsidyData || !Array.isArray(tmpSubsidyData)) {
        return;
      }

      // 保有枚数0枚の補助金は取り除く（nullの場合は利用可）
      tmpSubsidyData = tmpSubsidyData.filter(data => data.remainingCount !== 0);

      // 利用可能な期間内のものに絞り込む
      const subsidyData = this.filterWithinPeriod(tmpSubsidyData);

      // 利用可能補助金のID一覧を作成
      const ids = this.makeSubsidyIdList(subsidyData);

      if (ids.length == 0) return;

      const mapping = await this.getMapping(ids);

      // プランで利用可能な補助金一覧
      this.subsidyData = this.makeSubsidyList(subsidyData, mapping, ids);
    },
     /**
     * 利用可能補助金取得
     */
     async getCouponData() {
      const result = await this.$repositories('coupon').getSubsidyCouponList({ displayDiv: '2' });
      if (!Array.isArray(result)) {
       return [];
      }
      return result;
    },
    /**
     * 利用可能な期間内のものに絞り込む
     * @param {Array<object>} subsidyList 利用可能な補助金の一覧
     * @return {Array<object>} filterList 利用可能な期間内の補助金の一覧
     */
     filterWithinPeriod(subsidyList) {
      const today = moment().startOf('days') // 日付比較のため.startOf('days')で時間設定を00:00:00にする

      const filterList = subsidyList.filter(
        (s) =>
          moment(s.availableData.receptionDateFrom).isSameOrBefore(today, 'day') &&
          moment(s.availableData.receptionDateTo).isSameOrAfter(today, 'day') &&
          moment(s.availableData.applicableDateFrom).isSameOrBefore(today, 'day') &&
          moment(s.availableData.applicableDateTo).isSameOrAfter(today, 'day') &&
          this.checkWithinLimApplicableDate(s.availableData.priceList, today)
      )
      return filterList;
    },
    /**
     * 申込日が限定適用期間内か判定する
     * @param {Array<object>} priceList 補助金単価リスト
     * @param {moment} today 申込日
     * @return {Boolean} 申込期間内：true, 申込期間外：false
     */
     checkWithinLimApplicableDate(priceList, today) {
      if (priceList && priceList.length > 0) {
        // 1つでも申込日を含む限定適用期間があれば利用可能と判定する
        const len = priceList.length
        for (let i = 0; i < len; i++) {
          const price = priceList[i];
          if (moment(price.limApplicableDateFrom).isSameOrBefore(today, 'day') &&
            moment(price.limApplicableDateTo).isSameOrAfter(today, 'day')) {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * 利用可能補助金のID一覧を作成
     * @param {Array<object>} subsidyList 利用可能な補助金の一覧
     * @return {Array<string>} 利用可能な補助金のID一覧
     */
     makeSubsidyIdList(subsidyList) {
      let ids = [];
      const len = subsidyList.length;
      for (let i = 0; i < len; i++) {
        const subsidy = subsidyList[i].availableData,
          id = subsidy.subsidyId;
        ids.push(id);
      }
      return ids;
    },
    /**
     * 補助金のマッピングを取得する
     * @param {Array<string>} subsidyIds 利用可能な補助金のID一覧
     * @return {Array<string>} 補助金のマッピング結果
     */
    async getMapping(subsidyIds) {
      let params = {
        id: subsidyIds.join("-"), // 補助金ID
        targetType: "0", // 補助金
        catLrgClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catLrgClassCd || '', // 大カテゴリID
        catMidClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catMidClassCd || '', // 中カテゴリID
        catSmlClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catSmlClassCd || '', // 小カテゴリID
        menuNo:  this.menu?.menuBasicInfo?.menuNo || '',// メニューNo
        planId: this.menu?.planDetails[0]?.planId || '', // プランID
        receivableFlag:this.planDetail?.planUsage?.usageDetail?.receivableFlag || '1', // 売掛金フラグ(0:売掛金未対応, 1:売掛金対応)
        ticketExclusionFlag: this.plans?.planDetail?.planUsage?.usageDetail?.ticketExclusionFlag || '0', // チケット除外フラグ(0:対象外, 1:対象)
        buppanExclusionFlag: this.planDetail?.planUsage?.usageDetail?.buppanExclusionFlag || '0', // 物販除外フラグ(0:対象外, 1:対象)
        famiExclusionFlag: this.planDetail?.planUsage?.usageDetail?.famiExclusionFlag || '0' // ファミポート除外フラグ(0:対象外, 1:対象)
      };  
      const res = await this.$repositories("coupon").getStationMapping(params);
      // // API実行エラーの場合
      // if (res.isError) {
      //   this.loading(false);
      //   this.$router.push("/404");
      //   return;
      // }
      return res.bsSubsidyMappingArray;
    },
    /**
     * プランで利用可能な補助金一覧を作成する
     * @param {Array<string>} subsidyList 利用可能な補助金の一覧
     * @param {Array} mappingList 補助金のマッピング結果
     * @param {Array} ids 利用可能な補助金のID一覧
     * @return {Array<object>} プランで利用可能な補助金一覧
     */
    makeSubsidyList(subsidyList, mappingList, ids) {
      let subsidy = [];
      const len = mappingList.length;
      for (let i = 0; i < len; i++) {
        const id = mappingList[i].subsidyId;
        const idxSubsidyId = subsidyList.findIndex(x=> x?.availableData?.subsidyId === id);
        if (idxSubsidyId > -1) {
          // 補助金一覧に存在する場合
          subsidy.push(subsidyList[idxSubsidyId]);
        }
      }
      this.sortSubsidyList(subsidy);
      return subsidy;
    },
    /***
     * 補助金一覧の並び替え(現在が含まれる限定適用期間のTOの早い順)
     * @param {Array<object>} 補助金の情報一覧
     */
     sortSubsidyList(subsidyList) {
      // 申込日が含まれる限定適用期間のTOの早い順にする
      subsidyList.sort((a, b) => {
        const aPrice = this.getPriceLimApplicableDateIncludeToday(a.availableData.priceList);
        const bPrice = this.getPriceLimApplicableDateIncludeToday(b.availableData.priceList);
        if (aPrice && aPrice.limApplicableDateTo && bPrice && bPrice.limApplicableDateTo) {
          return new Date(aPrice.limApplicableDateTo) - new Date(bPrice.limApplicableDateTo)
        }
        return 0;
      })
    },
    /***
     * 申込日が限定適用期間に含まれるを持つ補助金単価情報の取得
     * @param {Array<object>} 補助金単価情報一覧
     * @return {object} 補助金単価情報
     */
     getPriceLimApplicableDateIncludeToday(priceList) {
      const today = moment().startOf('days'); // 日付比較のため.startOf('days')で時間設定を00:00:00にする
      if (priceList && priceList.length > 0) {
        // 申込日が限定適用期間に含まれる補助金単価情報を返す
        const len = priceList.length;
        for (let i = 0; i < len; i++) {
          const price = priceList[i];;
          if (moment(price.limApplicableDateFrom).isSameOrBefore(today, 'day') &&
            moment(price.limApplicableDateTo).isSameOrAfter(today, 'day')) {
            return price;
          }
        }
      }
      return null;
    },
     /**
     * 利用可能補助金アイコン取得を行う
     * @param {Array} subsidyIds プランで利用可能な補助金一覧
     */
    async getSubsidyIcon(subsidyIds) {
      const params = {
        idData: this.makeIconReqParamsSubsidyInfo(subsidyIds),
        iconData: this.makeIconReqParamsPlanInfo()
      };

      const res = await this.$repositories("coupon").getIcons(params);
      if (res?.data?.availableIcon && res?.data?.availableIcon?.[0]) {
        this.iconData.push(res.data.availableIcon[0]);
      }
    },
    /**
     * カフェのアイコン取得を行う
     * @param {Array} カフェの契約IDで利用可能なアイコンを取得する
     *  => 契約IDはBFFでログイン情報から取得する
     */
     async getCafeIcon() {
      const idData = [
        {
          no: "0", 
          targetType: "1",
          id: "0000000" // 仮の値の為、BFFでカフェの契約IDをセットすること
        }
      ];
      const params = {
        idData: idData,
        iconData: this.makeIconReqParamsPlanInfo()
      };
      const res = await this.$repositories('coupon').getIcons(params);
      if (res.data.availableIcon) {
        this.iconData.push(res.data.availableIcon[0]);
      }
    },
    /**
     * 利用可能アイコン取得のリクエストパラメータidData(補助金一覧)を生成する
     * @param {Array<string>} subsidyList このプランで利用可能な補助金一覧
     * @return {Array} 作成したidDataの配列
     */
     makeIconReqParamsSubsidyInfo(subsidyList) {
      let idData = [];
      const len = subsidyList.length;
      for (let i = 0; i < len; i++) {
        idData.push({
          no: i, // UI側で重複しない値を設定する(識別用)
          targetType: "0",
          id: subsidyList[i].availableData.subsidyId
        });
      }
      return idData;
    },
    /**
    * 利用可能アイコン取得のリクエストパラメータiconData(プラン情報一覧)を生成する
    * @return {Array} 作成したiconDataの配列
    */
    makeIconReqParamsPlanInfo() {
      // いったんは1つのプランが紐づいていることを前提としたプログラムとする
      // Dev環境でDPのメニューに対してプランを2つ以上紐づけると申込時にエラーとなるため
      const iconData = [
        {
          no: 0,
          catLrgClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catLrgClassCd || '',
          catMidClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catMidClassCd || '',
          catSmlClassCd: this.menu?.menuBasicInfo?.categoryInfomation?.catSmlClassCd || '',
          menuNo: this.menu?.menuBasicInfo?.menuNo || '',
          planId: this.menu?.planDetails?.[0]?.planId || '',
          areaLrgClassCd: this.menu?.areaInfomation?.areaLrgClassCd || '',
          areaMidClassCd:  this.menu?.areaInfomation?.areaMidClassCd || '',
          areaSmlClassCd:  this.menu?.areaInfomation?.areaSmlClassCd || '',
          areaDtlClassCd:  this.menu?.areaInfomation?.areaDtlClassCd || '',
          receivableFlag: '1',
          ticketExclusionFlag: this.menu?.plans?.[0]?.planUsage?.usageDetail?.ticketExclusionFlag || '0',
          buppanExclusionFlag: this.menu?.plans?.[0]?.planUsage?.usageDetail?.buppanExclusionFlag || '0',
          famiExclusionFlag: this.menu?.plans?.[0]?.planUsage?.usageDetail?.famiExclusionFlag || '0'
        }
      ];
      return iconData;
    },
    getDpPlanBasicInfo() {
      if (this.$refs.routerViewRef && this.$refs.routerViewRef.planBasicInfo) {
        return this.$refs.routerViewRef.planBasicInfo
      }
      return null
    },
    // メニュー基本情報とcopyLabelを再取得する処理
    async refreshMenuAndCopyLabel() {
      // メニュー基本情報を再取得
      await this.getMenuBasicInfo()
      // DOM更新を待ってからcopyLabelを更新
      await this.$nextTick()
      // copyLabel computedを強制的に再計算
      this.$forceUpdate()
    },
  }
}
</script>

<style scoped lang="scss">
.p-pnt {
  margin-bottom: 3px;
}

@media screen and (max-width: 1023px) {
  .l-container {
    max-width: 1024px;
    width: 100%;  
  }  
}
.p-menus-no__summary {
        box-shadow: 0 1px 8px rgba(0 ,0, 0, 0.08);
}
.p-menus-no {
  .b-share_inner{
  margin-top: -1.5rem;
  }
  &__inner {
    margin-bottom: 1rem;
    @media screen and (max-width: 625px) {
      box-shadow: none;
    }
    &--plans {
      box-shadow: unset;
      
    }
  }
  &__summary {
    // padding: 2rem;
    @include mq() {
      padding: 0 0 0.625rem;
    }
  }
  &__menuInfo {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    @media screen and (max-width: 625px) {
      display: block;
    }
    &__menuNo {
      font-size: 0.875rem;
      color: #63666a;
      @include mq() {
        font-size: 0.6rem;
        color: #73767A;
      }
    }
    &__menulist {
      align-items: center;
      &__item {
        cursor: pointer;
      }
    }
    &__name {
      font-size: 1.2rem;
      &__not--location {
        @include mq() {
          margin-bottom: 1rem;
        }
      }
    }
    &__location {
      display: flex;
      align-items: center;
      margin-top: 1rem;
      font-size: 0.875rem;
      @include mq() {
        margin-bottom: 1rem;
      }
      li {
        &:not(:last-child) {
          margin-right: 0.5rem;
        }
      }
      &__button {
        margin-left: 1.5rem;
        @include mq() {
          min-width: 50px;
          margin-left: auto;
        }

        span {
          @include mq() {
            display: none;
          }
        }
      }
    }
  }
  &__footer-menu {
    &__block {
      margin-bottom: 3rem;
      overflow-x: auto;
      @include mq() {
        ul {
          flex-wrap: nowrap;
          width: calc((240px) * 4);
        }
      }
    }
  }
  &__slider {
    .swiper-container {
      width: 95%;
    }
    .swiper-button-prev {
      width: 40px;
      height: 40px;
      margin-left: 0;
      &::after {
        content: '';
      }
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
      margin-right: 0;
      &::after {
        content: '';
      }
    }
    &__inner {
      width: 100%;
      padding-bottom: 30px;
      img {
        object-fit: contain;
        width: 100%;
      }
    }
  }
}

</style>
<style scoped lang="scss">
.p-menus {
  &-no {
    &__menuInfo {
      align-items: center;
      @media screen and (max-width: 625px) {
        display: flex;
        align-items: flex-start;
      }
      &__menulist {
        display: flex;
        column-gap: 0.5rem;
        @media screen and (max-width: 625px) {
          display: none;
        }
        &__item {
          .favorited {
            color: red;
          }
        }
      }
      &__name {
        @media screen and (max-width: 625px) {
          font-size: 18px;
          font-weight: bold;
        }
      }
      &__location {
        @media screen and (max-width: 625px) {
          font-size: 13px;
          justify-content: space-between;
        }
        > li:not(:last-child) {
          @media screen and (max-width: 625px) {
            margin-right: 0.25rem;
          }
        }
        svg {
          @media screen and (max-width: 625px) {
            display: inline;
            width: 20px;
            height: 20px;
            margin-top: 5px;
          }
        }
        &__text {
          display: flex;
          align-items: center;
        }
      }
      &__menuNo {
        @media screen and (max-width: 625px) {
          font-size: .625rem;
        }
      }
      &__label {
        flex: 1;
        .label-contents {
          @media screen and (max-width: 625px) {
          }
        }
        &.cat-nm {
          background-color: #edeef0;
          margin-right: 0.5rem;
          padding: 2px 0;
          @media screen and (max-width: 625px) {
            display: inline;
            background-color: #FFF8E5;
          }
        }
      }
      &__share {
        margin-left: .5rem;
      }
    }
  }
}

.p-menus-no-mt-15{
  margin-top: -1.5rem;
}

.title-left {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem 0;
  @media screen and (max-width: 625px) {

  }
}

.text-menu {
  font-size: 12px;
  color: #da291c;
  padding: 0 0.5rem 0 0.5rem;
  @media screen and (max-width: 625px) {
    color: #1F2021;
    font-size: .625rem;
  }
}
.c-button__tertiary {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  height: 32px;
  color: #63666a;
  @media screen and (max-width: 625px) {
    height: 24px;
    padding: 0 4px 0;
  }
  &.sp-button__tertiary {
    @media screen and (max-width: 625px) {
      font-size: 10px;
      height: auto;
      padding: 6px;
      line-height: 14px;
    }
  }
}

.content_btns_sp {
  display: none;
  @media screen and (max-width: 625px) {
    display: flex;
  }
}

.content_shareBtn {
  &_btn {
    @media screen and (max-width: 625px) {
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 12px;
      font-weight: bold;
      white-space: nowrap;
      margin-right: 4px;
      padding: 0 4px 0;
      border: 1px solid #cacccf;
      border-radius: 4px;
      svg {
        margin-right: 0;
        margin-left: 4px;
      }
    }
    &_link {
      display: none;
    }
    &_icon {
      padding-top: 5px;
    }
  }
}

.content_icons {
    display: flex;
    justify-content: left;
    align-items: center;
    margin-top: 12px;
}

// カフェ補助金アイコン
.cafe-subsidy-icon {
  color: #f4f5f6 !important;
  background-color: #0d76bf !important;
  margin-right: 8px;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 2px;
  margin-bottom: 12px;
}

// ベネポアイコン
.benepo-icon {
  color: #000000 !important;
  background-color: #FFD966 !important;
  margin-right: 8px;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 2px;
  margin-bottom: 12px;
}

@media screen and (max-width: $contentWidthS) {
  .sm_wrapper {
    box-shadow: none;
  }
}

</style>